export default __webpack_public_path__ + "static/media/top-background.9523c4a8.svg";